import { env } from "../../../env";
const axios = require("axios").default;

const URL_ORI = `${env.REACT_APP_API_URL}`;

export const getMaintenance = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Maintenance/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createMaintenance = (payload) => {
  return axios.post(`${URL_ORI}/api/Maintenance`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getIdMaintenance = (id) => {
  return axios
    .get(`${URL_ORI}/api/Maintenance/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateMaintenance = (payload) => {
  return axios.put(`${URL_ORI}/api/Maintenance`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updateMaintenanceStartWorkFlow = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Maintenance/StartWorkFlow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateMaintenanceSetStatus = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Maintenance/setstatus`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateMaintenanceCancel = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Maintenance/Cancel`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateMaintenanceConfirm = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Maintenance/Confirm`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateMaintenanceAmmend = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Maintenance/ammend`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const deleteMaintenance = (payload) => {
  return axios.delete(`${URL_ORI}/api/Maintenance`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const createMaintenanceVehicles = (payload) => {
  return axios
    .post(`${URL_ORI}/api/Maintenance/addVehicles`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const deleteMaintenanceVehicles = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/Maintenance/deleteVehicles`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const createMaintenanceParties = (payload) => {
  return axios
    .post(`${URL_ORI}/api/Maintenance/addParties`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const uploadMaintenance = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(
      `${URL_ORI}/api/Maintenance/UploadMaintenanceVehicle?object_id=${id}`,
      formData
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const uploadMaintenanceWorkflow = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(
      `${URL_ORI}/api/Maintenance/UploadMaintenanceWorkflowVehicle?object_id=${id}`,
      formData
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const uploadInspect = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(
      `${URL_ORI}/api/Maintenance/UploadMaintenanceInspectionVehicle?object_id=${id}`,
      formData
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const uploadRePdi = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(
      `${URL_ORI}/api/Maintenance/UploadREPDIINWorkflow?object_id=${id}`,
      formData
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const uploadRePdiout = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(`${URL_ORI}/api/Maintenance/UploadREPDIOUT?object_id=${id}`, formData)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// Vehicle

export const getVehicle = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Maintenance/SearchVehiclesinMaintenance`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const createVehicle = (payload) => {
  return axios
    .post(`${URL_ORI}/api/Maintenance/AddVehicles`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateVehicle = (payload) => {
  return axios.put(`${URL_ORI}/api/Vehicle`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const deleteVehicle = (payload) => {
  return axios.delete(`${URL_ORI}/api/Vehicle`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

// party
export const getparty = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Maintenance/searchpartyInMaintenance`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const createParty = (payload) => {
  return axios
    .post(`${URL_ORI}/api/Maintenance/AddParties`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateParty = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Maintenance/UpdateParty`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const deleteParty = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/Maintenance/deleteParties`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// Transportations
export const getTransportations = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Maintenance/SearchTransportinMaintenance`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const createTransportations = (payload) => {
  return axios
    .post(`${URL_ORI}/api/Maintenance/AddTransportation`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateTransportations = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Maintenance/UpdateTransportation`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const deleteTransportations = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/Maintenance/deleteTransportation`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// Generate Excel
export const getGenerateExcelBlob = (payload) => {
  return axios
    .post(
      `${URL_ORI}/api/RDM/GenerateExcel`,
      payload,
      {
        responseType: 'blob',
      }
    )
    .catch((error) => {
      if (error.response) {
        console.log(error.response, "eerorr");

        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
